export default "__VITE_ASSET__zl3ZDGGH__"